import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { cn, formatNumber } from '@/lib/utils';

export function Contracts() {
  const { data, isLoading } = useQuery({
    queryKey: ['contracts'],
    queryFn: () => api.getContracts(),
  });

  const contracts = data?.contracts || [];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-lg font-semibold">Contracts</h2>
          <p className="text-sm text-muted-foreground">
            Manage ICE contract specifications and limits
          </p>
        </div>
        <button className="h-9 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90">
          + Add Contract
        </button>
      </div>

      <div className="rounded-lg border bg-card">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b bg-muted/50">
                <th className="px-6 py-3 text-left text-sm font-medium text-muted-foreground">Symbol</th>
                <th className="px-6 py-3 text-left text-sm font-medium text-muted-foreground">Product</th>
                <th className="px-6 py-3 text-left text-sm font-medium text-muted-foreground">Exchange</th>
                <th className="px-6 py-3 text-left text-sm font-medium text-muted-foreground">Delivery</th>
                <th className="px-6 py-3 text-right text-sm font-medium text-muted-foreground">Spot Limit</th>
                <th className="px-6 py-3 text-right text-sm font-medium text-muted-foreground">Single Limit</th>
                <th className="px-6 py-3 text-right text-sm font-medium text-muted-foreground">All Limit</th>
                <th className="px-6 py-3 text-center text-sm font-medium text-muted-foreground">Status</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={8} className="px-6 py-8 text-center text-muted-foreground">
                    Loading contracts...
                  </td>
                </tr>
              ) : contracts.length === 0 ? (
                <tr>
                  <td colSpan={8} className="px-6 py-8 text-center text-muted-foreground">
                    No contracts found
                  </td>
                </tr>
              ) : (
                contracts.map((contract) => (
                  <tr key={contract.id} className="border-b last:border-0 hover:bg-muted/50">
                    <td className="px-6 py-4 font-medium font-mono">{contract.symbol}</td>
                    <td className="px-6 py-4">
                      <span className="px-2 py-1 rounded bg-muted text-xs font-medium">
                        {contract.productCode}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm">{contract.exchange}</td>
                    <td className="px-6 py-4 text-sm">{contract.deliveryMonth}</td>
                    <td className="px-6 py-4 text-right font-mono">
                      {formatNumber(contract.spotMonthLimit)}
                    </td>
                    <td className="px-6 py-4 text-right font-mono">
                      {formatNumber(contract.singleMonthLimit)}
                    </td>
                    <td className="px-6 py-4 text-right font-mono">
                      {formatNumber(contract.allMonthsLimit)}
                    </td>
                    <td className="px-6 py-4 text-center">
                      <span className={cn(
                        'px-2 py-1 rounded-full text-xs font-medium',
                        contract.isActive ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
                      )}>
                        {contract.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
